import { Tooltip, Typography } from '@mui/material';
import React, { FC } from 'react';
import { GameCurrencyWithFee } from 'modules/game-payments/components';

interface ComponentProps {
  label: string;
  tooltipLabel: string;
  entryFee: number | undefined;
  needShowSwap: boolean;
}

export const PaidActionText: FC<ComponentProps> = ({
  label,
  tooltipLabel,
  entryFee,
  needShowSwap,
}) => {
  return (
    <Typography>
      {label}
      {entryFee ? (
        <>
          <Typography component="span" sx={{ textTransform: 'none' }}>
            {' for '}
          </Typography>
          <GameCurrencyWithFee amount={entryFee} />
        </>
      ) : null}
      <Tooltip
        title={`${tooltipLabel} after swap to cover entry platform fees`}
        disableHoverListener={!needShowSwap}
      >
        <Typography component="span">{needShowSwap ? ' *' : null}</Typography>
      </Tooltip>
    </Typography>
  );
};
